import { styled } from '@mui/material/styles'

export const MeasurementInput = styled('div')(({ theme }) => ({
  ...theme.layout.flexColumn,
  width: '100%',
}))
